import { PlaceRef } from "@/types/entity"
import { PlacePlaceholder } from "@/types/place"
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"

import { freeze } from "@/lib/utils/collections"
import { RootState } from "./redux-store"

export interface SearchResultMapSliceState {
  geocodedPlacesByRef: Record<PlaceRef, PlacePlaceholder>
}

export const searchResultMapSliceInitialState =
  freeze<SearchResultMapSliceState>({
    geocodedPlacesByRef: {},
  })

const searchResultMapSlice = createSlice({
  name: "searchResultMap",
  initialState: searchResultMapSliceInitialState,
  reducers: {
    setGeocodedSearchResultPlaces: (
      state,
      action: PayloadAction<Record<PlaceRef, PlacePlaceholder>>
    ) => {
      state.geocodedPlacesByRef = action.payload
    },
    clearGeocodedSearchResultPlaces: (state) => {
      state.geocodedPlacesByRef = {}
    },
  },
})

const selectSliceState = (state: RootState) => state.searchResultMapSlice

export const selectGeocodedSearchResultPlacesByRef = createSelector(
  [selectSliceState],
  (state) => state.geocodedPlacesByRef
)

export const selectGeocodedSearchResultPlace = createSelector(
  [
    selectGeocodedSearchResultPlacesByRef,
    (_state: RootState, ref: PlaceRef) => ref,
  ],
  (byRef, ref) => byRef[ref]
)

export const {
  setGeocodedSearchResultPlaces,
  clearGeocodedSearchResultPlaces,
} = searchResultMapSlice.actions

export default searchResultMapSlice
